// extracted by mini-css-extract-plugin
export default {"buttonAvatarCancel":"styles_buttonAvatarCancel__Z4cMK","buttonAvatarSave":"styles_buttonAvatarSave__E1iJk"};